import React from 'react';
import { IoLogoWhatsapp } from 'react-icons/io5';

const Integrations = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-slate-900">Integrations</h1>
        <p className="text-sm text-slate-500 mt-1">Connect third-party services to enhance your workflow.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* WABA Coming Soon card */}
        <div className="relative bg-white border border-slate-200 rounded-2xl p-5 flex flex-col gap-3 opacity-70">
          <div className="absolute top-3 right-3 text-xs font-semibold px-2 py-0.5 bg-amber-100 text-amber-700 rounded-full">
            Coming Soon
          </div>
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ backgroundColor: '#25D36620' }}>
            <IoLogoWhatsapp size={22} color="#25D366" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-slate-800">WhatsApp Business API</h3>
            <p className="text-xs text-slate-500 mt-1 leading-relaxed">
              Send automated WhatsApp messages directly from ClustrOps — without leaving the app. Powered by WABA.
            </p>
          </div>
          <div className="mt-auto">
            <button
              disabled
              className="w-full px-4 py-2 text-xs font-semibold rounded-lg bg-slate-100 text-slate-400 cursor-not-allowed"
            >
              Connect (Coming Soon)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integrations;
